export interface Webhook {
	id: string
	uri: string
	api_key?: string
	enabled: boolean
	events: string[]
}

export interface CreateWebhookPayload {
	uri: string
	api_key?: string
	events: string[]
	enabled?: boolean
}

export type UpdateWebhookPayload = Partial<Omit<Webhook, 'id' | 'events'>> & {
	events: string[]
}

export interface WebhooksPageVM {
	documents: Webhook[]
	total: number
}

export interface TestWebhookResultVM {
	success: boolean
	message: string
	status_code?: number
	webhook_events?: unknown
}

const EVENT_DISPLAY_NAMES: Record<string, string> = {
	'contact.connected': 'Contact connected',
	'contact.notes.changed': 'Contact notes changed',
	'contact.scrapped': 'Contact scrapped',
	'invitation.sent': 'Invitation sent',
	'contact.qualification.changed': 'Contact qualification changed',
	'message.sent': 'Message sent',
	'message.received': 'Message received'
}

export function webhookEventToDisplayName(event: string): string {
	const result = EVENT_DISPLAY_NAMES[event] ?? event
	return result;
}